module.exports = __webpack_public_path__ + "static/media/doctor-guitar-xray.b26c9036.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/RepairPage/assets/doctor-guitar-xray.png
// module id = 535
// module chunks = 0